import { restRequest } from 'core/utils/backend-service';
import { BulkUserLocationsApi, UserDetailApi } from './user-locations.api';
import { bulkUserLocationsEndpoint, userDetailEndpoint } from './user-locations.constants';

/**
 * Reads the user's current assignment fresh rather than seeding the dialog from the list row: the
 * write is a full-set replace, so building it from a possibly stale list would silently drop an
 * assignment made elsewhere.
 */
export const getUserAssignedLocationIds = (userId: string): Promise<string[]> =>
    restRequest('GET', userDetailEndpoint(userId))
        .then((response) => response.json())
        .then((user: UserDetailApi) => user.locations ?? []);

export const replaceBulkUserLocations = (userIds: string[], locationIds: string[]): Promise<void> => {
    const body: BulkUserLocationsApi = { userIds, locationIds };

    return restRequest('PUT', bulkUserLocationsEndpoint, { body }).then(() => undefined);
};
